var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAluminiumSliding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "as-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as-alu",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#C7CBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9AA0A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as-glass",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E7F3F2",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFE0DD",
    stopOpacity: 0.6
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 320,
    fill: "url(#as-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 60,
    width: 300,
    height: 200,
    rx: 4,
    fill: "url(#as-alu)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 68,
    width: 284,
    height: 184,
    rx: 2,
    fill: "#FBF5EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 252,
    width: 300,
    height: 10,
    fill: "#9AA0A6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 72,
    width: 134,
    height: 176,
    fill: "url(#as-glass)",
    stroke: "#C7CBCE",
    strokeWidth: 6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 72,
    width: 150,
    height: 176,
    fill: "url(#as-glass)",
    stroke: "#9E2430",
    strokeWidth: 6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 150,
    width: 8,
    height: 36,
    rx: 3,
    fill: "#AD8720"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 90 L120 220",
    stroke: "#ffffff",
    strokeWidth: 6,
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230 90 L260 220",
    stroke: "#ffffff",
    strokeWidth: 6,
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9E2430"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 40 h34 l-10 -8 M334 40 l-10 8",
    stroke: "#9E2430",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 300,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "Aluminium Slidings")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAluminiumSliding);
export default __webpack_public_path__ + "static/media/aluminium-sliding.cfd2a12e64ab2f5e1267a68509b9a63f.svg";
export { ForwardRef as ReactComponent };